import React from 'react';
/*
    Holds Order Details so it can be accessed by components using the "useContext(OrderContext)" hook
 */
const OrderContext = React.createContext(null);
export default OrderContext;
